import store from '@state/store'
import routes from './routes'
import { createRouter, createWebHistory } from 'vue-router'
import {
  checkGenreValid,
  getPrefectureCodeFromAreaCode,
  getMunicipalityFromAreaCode,
  DISPLAYMODE,
} from '@state/modules/facility-search.js'

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0, left: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach(async (routeTo, routeFrom) => {
  // If this isn't an initial page load...
  console.log('[beforeEach]', routeTo.name, routeFrom.fullPath)

  if (routeTo.query && routeTo.query.login_flg == 1) {
    if (!sessionStorage.getItem('loginFlgRedirected')) {
      sessionStorage.setItem('loginFlgRedirected', '1')

      // 戻り先 URL（login_flg を除去）
      const newQuery = { ...routeTo.query }
      delete newQuery.login_flg

      const returnUrl =
        window.location.origin +
        routeTo.path +
        (Object.keys(newQuery).length
          ? `?${new URLSearchParams(newQuery).toString()}`
          : '')

      const ssoUrl = `${process.env.VUE_APP_SSO_URL}?qServiceId=${
        process.env.VUE_APP_SSO_ID
      }&qLoginStatusCheckFlg=1&qUrl=${encodeURIComponent(returnUrl)}`

      // 外部遷移（SPA終了）
      window.location.replace(ssoUrl)
      return false
    }

    return true
  }
  else {
    sessionStorage.removeItem('loginFlgRedirected');
  }

  if (routeTo.query && routeTo.query.login_flg == 0) {
    if (!sessionStorage.getItem('logoutHandled')) {
      sessionStorage.setItem('logoutHandled', '1')

      await store.dispatch('auth/logout')
      store.dispatch('facilitySearch/setDisplayMode', DISPLAYMODE.START)
      store.dispatch('facilitySearch/clearSearch')

      const newQuery = { ...routeTo.query }
      delete newQuery.login_flg

      return {
        path: routeTo.path,
        query: newQuery,
        replace: true,
      }
    }

    return true
  }
  else {
    sessionStorage.removeItem('logoutHandled');
  }


  if (routeTo.query && routeTo.query.SsnId) {
    if (!sessionStorage.getItem('ssnidHandled')) {
      sessionStorage.setItem('ssnidHandled', '1')

      localStorage.setItem('SsnId', routeTo.query.SsnId)

      const newQuery = { ...routeTo.query }
      delete newQuery.SsnId

      return {
        path: routeTo.path,
        query: newQuery,
        replace: true,
      }
    }

    return true
  }
  else {
    sessionStorage.removeItem('ssnidHandled');
  }

  /* ====================================================
   * ④ iframe mode
   * ==================================================== */
  var sPd = window.localStorage.getItem('post_data')
  if (sPd) {
    var oPd = JSON.parse(sPd)
    var SsnId = oPd.SsnId
    if (routeTo.query && routeTo.query.iframemode !== 'k5q87r2c' &&
      routeTo.params && routeTo.params.iframemode !== 'k5q87r2c' && SsnId ) {
      if (!sessionStorage.getItem('iframeHandled')) {
        sessionStorage.setItem('iframeHandled', '1')
        window.localStorage.setItem('SsnId', SsnId)
        const newQuery = { ...routeTo.query }
        delete newQuery.iframemode

        return {
          path: routeTo.path,
          query: newQuery,
          replace: true,
        }
      }
    }
    return true
  }
  else {
    sessionStorage.removeItem('iframeHandled');
  }


  if (routeTo.query && routeTo.query.iframemode === 'k5q87r2c') {
    window.sessionStorage.setItem('iframemode', '1')
  }


  if (routeFrom.name !== null) {
    const container = document.getElementById('jaf_container')
    if (routeFrom.name && container) {
      routeFrom.meta.containerScrollTop = container.scrollTop
    }
  }

  if (routeTo.name !== 'facility-detail' && routeTo.name !== 'coupon-detail') {
     store.dispatch('layout/disableCouponDetailAlive')
  }

  if (
    routeFrom.name === 'facility-search' &&
    routeTo.name === 'map' &&
    !routeFrom.meta.isBack
  ) {
    store.dispatch('layout/disableMapAlive')
  }

  if (routeTo.name == 'search-result' || routeTo.name == 'map') {
    if (routeTo.query) {
      if (routeTo.query.genre) {
        if (routeTo.query.genre == 'Z') {
          store.dispatch('facilitySearch/checkIsOnline')
          store.dispatch('facilitySearch/setTempIsOnline', true)
          store.dispatch('facilitySearch/setGenreCode', '')
          store.dispatch('facilitySearch/setTempGenre', '')
          sessionStorage.removeItem('SHOP')
        } else if (checkGenreValid(routeTo.query.genre)) {
          store.dispatch('facilitySearch/setGenreCode', routeTo.query.genre)
          store.dispatch('facilitySearch/setTempGenre', routeTo.query.genre)
        } else {
          return { name: 'facility-search' }
        }
      } else {
        store.dispatch('facilitySearch/setGenreCode', '')
        store.dispatch('facilitySearch/setTempGenre', '')
      }

      if (routeTo.query.query) {
        store.dispatch('facilitySearch/setSearchWord', routeTo.query.query)
        store.dispatch('facilitySearch/setTempSearchWord', routeTo.query.query)
      } else {
        store.dispatch('facilitySearch/setSearchWord', '')
        store.dispatch('facilitySearch/setTempSearchWord', '')
      }

      if (routeTo.query.area) {
        store.dispatch('facilitySearch/setAreaCode', routeTo.query.area)
        store.dispatch(
          'facilitySearch/setTempPrefecture',
          getPrefectureCodeFromAreaCode(routeTo.query.area)
        )
        store.dispatch(
          'facilitySearch/setTempMunicipality',
          getMunicipalityFromAreaCode(routeTo.query.area)
        )
      } else {
        store.dispatch('facilitySearch/setAreaCode', '')
        store.dispatch('facilitySearch/setTempPrefecture', '')
        store.dispatch('facilitySearch/setTempMunicipality', '')
      }
      if (routeTo.query.online && routeTo.query.online == 1) {
        store.dispatch('facilitySearch/checkIsOnline')
        store.dispatch('facilitySearch/setTempIsOnline', true)
      } else if (routeTo.query.genre != 'Z') {
        store.dispatch('facilitySearch/uncheckIsOnline')
        store.dispatch('facilitySearch/setTempIsOnline', false)
      }

      if (routeTo.query.limited && routeTo.query.limited == 1) {
        store.dispatch('facilitySearch/checkIsLimited')
        store.dispatch('facilitySearch/setTempIsLimited', true)
      } else {
        store.dispatch('facilitySearch/uncheckIsLimited')
        store.dispatch('facilitySearch/setTempIsLimited', false)
      }

      if (routeTo.query.coupon && routeTo.query.coupon == 1) {
        store.dispatch('facilitySearch/checkCoupon')
        store.dispatch('facilitySearch/setTempExistCoupon', true)
      } else {
        store.dispatch('facilitySearch/uncheckCoupon')
        store.dispatch('facilitySearch/setTempExistCoupon', false)
      }

      if (routeTo.query.premium && routeTo.query.premium == 1) {
        store.dispatch('facilitySearch/checkIsPremiam')
        store.dispatch('facilitySearch/setTempIsPremiam', true)
      } else {
        store.dispatch('facilitySearch/uncheckIsPremiam')
        store.dispatch('facilitySearch/setTempIsPremiam', false)
      }

      if (routeTo.query.newshop && routeTo.query.newshop == 1) {
        store.dispatch('facilitySearch/checkIsNewShop')
        store.dispatch('facilitySearch/setTempIsNewShop', true)
      } else {
        store.dispatch('facilitySearch/uncheckIsNewShop')
        store.dispatch('facilitySearch/setTempIsNewShop', false)
      }

      if (routeTo.query.nowAround && routeTo.query.nowAround == 1) {
        store.dispatch('facilitySearch/setIsNowAround', true)
        store.dispatch('facilitySearch/setTempIsNowAround', true)
      } else {
        store.dispatch('facilitySearch/setIsNowAround', false)
        store.dispatch('facilitySearch/setTempIsNowAround', false)
      }

      if (
        routeTo.query.pointSearch &&
        routeTo.query.pointSearch == 1 &&
        routeTo.query.lon &&
        routeTo.query.lat
      ) {
        store.dispatch('facilitySearch/checkPointSearch')
        store.dispatch('facilitySearch/setTempIsPointSearch', true)
        let location = {
          lon: routeTo.query.lon,
          lat: routeTo.query.lat,
        }
        store.dispatch('facilitySearch/setLonLat', location)
      } else {
        store.dispatch('facilitySearch/uncheckPointSearch')
        store.dispatch('facilitySearch/setTempIsPointSearch', false)
      }
    } else {
      store.dispatch('facilitySearch/clearSearch')
      return { name: 'facility-search' }
    }
  }

  return true
})

/* ======================================================
 * beforeResolve
 * ====================================================== */
router.beforeResolve(async (routeTo, routeFrom) => {
  console.log('[beforeResolve]', routeTo.name, routeFrom.fullPath)

  if (routeTo.name === 'system-error') {
    return true
  }

  try {

    await store.dispatch('auth/logIn')

    for (const route of routeTo.matched) {
      if (route.meta && route.meta.beforeResolve) {
        await route.meta.beforeResolve(routeTo, routeFrom)
      }
    }
  } catch {

    return { name: 'system-error' }
  }

  return true
})

router.onError(() => {
  window.location.reload()
})

export default router
